// Jahr.KW.Release

// This Version gets automatically updated by the build process and so also in the GitLab-CI.
const VERSION = '2026.37.3';
const REVISION = '4ca50a3641';
module.exports = { VERSION, REVISION };